export default __webpack_public_path__ + "static/media/Lens_Abstracted_darkmode.60a4f874.svg";